import React from "react";
import "./pages.css";

import input from "../images/input (high res).png";
import cbio from "../images/cBioPortal (high res).png";
import UCCS from "../images/ucsc (high res).png";
import clinvar from "../images/clinvar (high res).png";
import trials from "../images/clinicaltrials (high res).png";
import smart from "../images/smart search (high res).png";
import civic from "../images/civic (high res).png";
import exp from "../images/exportGuide.png";

function Guide() {
  return (
    <div className="about_body">
      <h1>Guide</h1>
      <img className="images" src={input} alt="" /> <br />
      Input the HUGO gene ID of the gene of interest (eg KRAS, EGFR, BRCA), and
      if known, the relevant peptide change and codon change. Click the submit
      button.
      <br /> <br />
      <img className="images" src={smart} alt="" /> <br />
      If no peptide and/or codon change has been selected, the relevant dropdown
      menus will provide possible peptide and codon changes which have been
      linked to the gene in the COSMIC database. Selecting a peptide change or
      codon change from the dropdown menus will automatically update the query.{" "}
      <br /> <br />
      After submitting the query, simply scroll down to view information from
      the desired database. <br /> <br />
      <img className="images" src={exp} alt="" /> <br />
      If the data needs to be downloaded, the Export All Databases button under
      the data entry section provides all the data in one excel file, while each
      database section can also be exported separately by clicking on the link
      below the database name. <br /> <br />
      <img className="images" src={clinvar} alt="" /> <br />
      In the ClinVar screen, the user is provided the ClinVar site loaded to the
      relevant search page for their query, which they can then use as normal,
      including finding Interpretations, Conditions, and other variant
      information. <br /> <br />
      <img className="images" src={cbio} alt="" /> <br />
      In the cBioPortal screen, the user is provided a graph which details how
      many times the gene shows up in each of the studies stored in cBioPortal,
      which allows users to see how common the mutation is in the selected
      cancer. <br /> <br />
      <img className="images" src={UCCS} alt="" /> <br />
      In the UCCS Genome Browser screen, the user is provided a shortcut to the
      genome browser of the selected variant, which provides relevant
      information on the location of the gene and sequence alignments. <br />{" "}
      <br />
      <img className="images" src={trials} alt="" /> <br />
      In the ClinicalTrials.gov screen, the user is provided with a table which
      has an entry for each clinical trial relevant to the query, and provides
      the Status, Study Title, Conditions, Interventions, and Locations for each
      trial.
      <img className="images" src={civic} alt="" /> <br />
      In the CIViC screen, the user is provided with a table which has
      expert-curated information on the clinical significance of the queried
      variants.
    </div>
  );
}

export default Guide;
